import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { SlMagnifier } from "react-icons/sl";


/**
 * 
 * @param {param} mahnung bool, true if invoice is mahnung
 * @param {param} storno bool, true if invoice is storno
 * @param {param} item object that should be displayed
 * @param {param} noItem bool, true if array is empty
 * @param {param} pdfReader function to display pdf in modal 
 * 
 * @returns <li> list item
 */
const DetailedListItem = ({mahnung, storno, item, noItem, pdfReader }) => {

    const [showDetails, setShowDetails] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);


    // Function to download pdfs
    const downloadPdf = (e) => {
        e.preventDefault();
        setIsDownloading(true);
        var linkSource = null;
        var fileName = "";

        if (mahnung) {
            linkSource = `data:application/pdf;base64,${item.x_file_mahnung}`; 
            fileName = item.x_file_mahnung_name;

        } else if (storno) {
            linkSource = `data:application/pdf;base64,${item.x_file_stornorechnung}`; 
            fileName = item.x_file_stornorechnung_name;
        } else {
            if (item.x_file_abrechnung !== undefined && item.x_file_abrechnung !== "False") { linkSource = `data:application/pdf;base64,${item.x_file_abrechnung}`; fileName = item.x_file_abrechnung_name; }
            if (item.x_file_vorschreibung !== undefined && item.x_file_vorschreibung !== "False") { linkSource = `data:application/pdf;base64,${item.x_file_vorschreibung}`; fileName = item.x_file_vorschreibung_name; }
            if (item.x_file_poolrechnung !== undefined && item.x_file_poolrechnung !== "False") { linkSource = `data:application/pdf;base64,${item.x_file_poolrechnung}`; fileName = item.x_file_poolrechnung_name; }            
        }

        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setIsDownloading(false);
    };

    const readPdf = (e) => {
        e.preventDefault();
        if (mahnung) {
            return pdfReader(item.x_file_mahnung);

        } else if (storno) {
            return pdfReader(item.x_file_stornorechnung);

        } else {
            if (item.x_file_abrechnung !== undefined && item.x_file_abrechnung !== "False") return pdfReader(item.x_file_abrechnung);
            if (item.x_file_vorschreibung !== undefined && item.x_file_vorschreibung !== "False") return pdfReader(item.x_file_vorschreibung);
            if (item.x_file_poolrechnung !== undefined && item.x_file_poolrechnung !== "False") return pdfReader(item.x_file_poolrechnung);
        }

    }

    return (
        <li>
            {noItem ?
                `Keine Dokumente gefunden`
                :
                item.x_file_abrechnung ?
                    <>
                        <Row onClick={() => setShowDetails(!showDetails)}>
                            <Col xs={showDetails ? "12" : "10"} xl={showDetails ? "12" : "8"}>
                                <div className={`animate__animated ${showDetails ? 'animate__zoomIn text-center' : 'animate__slideInRight'}`}>
                                    {
                                        item.x_file_mahnung_name !== "False" ? 'Mahnung' :
                                            item.x_file_stornorechnung_name !== "False" ? 'Stornorechnung' :
                                                'Abrechnung'
                                    } &nbsp;
                                    <small className="text-muted">
                                        {new Date(item.create_date).toLocaleDateString('DE-de')}
                                    </small></div>
                            </Col>
                            <Col hidden={showDetails} xs="2" xl="4" className="text-end">
                                <BsThreeDotsVertical />
                            </Col>
                        </Row>
                        <Row className="mt-3" hidden={showDetails === false} onClick={() => setShowDetails(!showDetails)}>
                            <Col xs="12" md="6" xl="6">
                                <span className="text-muted">Eingangsdatum</span><br />
                                {new Date(item.x_eingangsdatum).toLocaleDateString('DE-de')}
                            </Col>
                            <Col xs="12" md="6" xl="6">
                                <span className="text-muted">Abrechnungszeitraum</span><br />
                                {new Date(item.x_abrechnungszeitraum_von).toLocaleDateString('DE-de')} - {new Date(item.x_abrechnungszeitraum_bis).toLocaleDateString('DE-de')}
                            </Col>
                        </Row>
                        <Row className="mt-3" hidden={showDetails === false}>
                            <Col xs="6" xl="6" className="text-center border-right">
                                <a href="download/" onClick={e => downloadPdf(e)} className="link-energo"><FaCloudDownloadAlt /> Download</a>
                            </Col>
                            <Col xs="6" xl="6" className="text-center">
                                <a href="ansehen/" onClick={e => readPdf(e)} className="link-energo"><SlMagnifier /> Ansehen</a>
                            </Col>
                        </Row>
                    </>
                    :
                    item.x_file_poolrechnung ?
                        <>
                            <Row onClick={() => setShowDetails(!showDetails)}>
                                <Col xs={showDetails ? "12" : "10"} xl={showDetails ? "12" : "10"}>
                                    <div className={`animate__animated ${showDetails ? 'animate__zoomIn text-center' : 'animate__slideInRight'}`}>
                                        {item.x_rechnungsart} &nbsp;
                                        <small className="text-muted">
                                            {new Date(item.create_date).toLocaleDateString('DE-de')}
                                        </small>
                                    </div>
                                </Col>
                                <Col hidden={showDetails} xs="2" xl="2" className="text-end">
                                    <span><BsThreeDotsVertical /></span>
                                </Col>
                            </Row>
                            <Row className="mt-3" hidden={showDetails === false} onClick={() => setShowDetails(!showDetails)}>
                                <Col xs="12" xl="6">
                                    <span className="text-muted">Rechnungsnummer</span><br />
                                    {item.x_rechnungsnummer}
                                </Col>
                                <Col xs="12" xl="6">
                                    <span className="text-muted">Rechnungsdatum</span> <br />
                                    {new Date(item.x_rechnungsdatum).toLocaleDateString('DE-de')}
                                </Col>
                            </Row>
                            <Row className="mt-3" hidden={showDetails === false}>
                                <Col xs="6" xl="6" className="text-center border-right">
                                    <a href="download/" onClick={e => downloadPdf(e)} className="link-energo"><FaCloudDownloadAlt /> Download</a>
                                </Col>
                                <Col xs="6" xl="6" className="text-center">
                                    <a href="ansehen/" onClick={e => readPdf(e)} className="link-energo"><SlMagnifier /> Ansehen</a>
                                </Col>
                            </Row>
                        </>
                        :
                        item.x_file_vorschreibung ?
                            <>
                                <Row onClick={() => setShowDetails(!showDetails)}>
                                    <Col xs={showDetails ? "12" : "10"} xl={showDetails ? "12" : "10"}>
                                        <div className={`animate__animated ${showDetails ? 'animate__zoomIn text-center' : 'animate__slideInRight'}`}>
                                            {
                                                item.x_file_mahnung_name !== 'False' ? "Mahnung" :
                                                    "Vorschreibung"
                                            } &nbsp;
                                            <small className="text-muted">
                                                {new Date(item.create_date).toLocaleDateString('DE-de')}
                                            </small>
                                        </div>
                                    </Col>
                                    <Col hidden={showDetails} xs="2" xl="2" className="text-end">
                                        <span><BsThreeDotsVertical /></span>
                                    </Col>
                                </Row>
                                <Row className="mt-3" hidden={showDetails === false}>
                                    <Col xs="6" xl="6" className="text-center border-right">
                                        <a href="download/" onClick={e => downloadPdf(e)} className="link-energo"><FaCloudDownloadAlt /> Download</a>
                                    </Col>
                                    <Col xs="6" xl="6" className="text-center">
                                        <a href="ansehen/" onClick={e => readPdf(e)} className="link-energo"><SlMagnifier /> Ansehen</a>
                                    </Col>
                                </Row>
                            </>
                            :
                            null
            }
        </li>
    )
}
export default DetailedListItem;